import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Axios from 'axios';
import parse from 'html-react-parser';

import { BackDropLoad } from './LoadingBackDrop';
import { Loading } from './Loading';
import { UserContext, SnackbarContext } from './userContext';
import { AutoCompLoc } from './AutoCompLoc.jsx';
import {
  AccountHeader,
  FormCard,
  Field,
  SelectField,
  ToggleSwitch,
  PrimaryButton,
  Icon,
} from './myacc/primitives';

export const CompleteProfile = () => {
  const history = useNavigate();

  const [loading, setLoading] = useState(true);

  const { user, setUser } = useContext(UserContext);
  const { setSnack } = useContext(SnackbarContext);

  const [cats, setCats] = useState();
  const [subcats, setSubcats] = useState();

  const [cat, setCat] = useState('0');
  const [subcat, setSubcat] = useState('0');

  const [supname, setSupname] = useState('');
  const [loc, setLoc] = useState('');
  const [email, setEmail] = useState('');
  const [wait, setWait] = useState(false);
  const [exp, setExp] = useState('');
  const [qual, setQual] = useState('');
  const [courses, setCourses] = useState('');
  const [showhide, setShowhide] = useState('1');
  const [error, setError] = useState(0);
  const [catDetails, setCatDetails] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
    Axios.get('/new_apis/getsignupdata', {
      headers: { key: 'dqweqwe123y97qhduiasd$@^!*#&bjasdja&^&@!#' },
    }).then((res) => {
      if (res.data.status === 1) {
        setCats(res.data.cats);
        setSubcats(res.data.subcats);
        setLoading(false);
      }
    });
  }, []);

  const getCatDetails = (category) => {
    setWait(true);
    Axios.post('/new_apis/cat_details', { cat: category }).then((res) => {
      setWait(false);
      if (res.data.status === true) setCatDetails(res.data.msg);
    });
  };

  const updateLoc = (l) => setLoc(l);

  const finishProfile = (e) => {
    e.preventDefault();
    setError(0);

    if (cat === '0') {
      setError(1);
      setSnack({ message: 'Please select your category.', type: 'error', open: true, direction: 'center' });
      return;
    }
    if ((cat === '6' || cat === '7') && subcat === '0') {
      setError(2);
      setSnack({ message: 'Please select your sub-category.', type: 'error', open: true, direction: 'center' });
      return;
    }
    if ((cat !== '6' && cat !== '7' && cat !== 'a') && supname === '') {
      setError(3);
      setSnack({ message: 'Please enter the registered supplier / service provider name.', type: 'error', open: true, direction: 'center' });
      return;
    }
    if ((cat !== '6' && cat !== '7' && cat !== 'a') && !email.includes('@')) {
      setError(4);
      setSnack({ message: 'Please enter a valid email ID.', type: 'error', open: true, direction: 'center' });
      return;
    }
    if (loc === '') {
      setError(8);
      setSnack({ message: 'Please select your location from the suggestions.', type: 'error', open: true, direction: 'center' });
      return;
    }

    setWait(true);
    const formData = {
      uid: user.user_id,
      cat,
      supname,
      subcat,
      email,
      loc,
      qual,
      exp,
      showhide,
      courses,
    };
    Axios.post('/new_apis/complete_profile', formData, { headers: { tkn: user.token } }).then((res) => {
      if (res.data.status === 1) {
        setWait(false);
        setSnack({ message: res.data.msg, type: 'success', open: true, direction: 'left' });
        setUser(res.data.user_data);
        history('/');
      } else if (res.data.status === 2) {
        setWait(false);
        setSnack({ message: res.data.msg, type: 'error', open: true, direction: 'center' });
      }
    });
  };

  if (loading) return <Loading />;

  const showSupName = cat !== '7' && cat !== '6' && cat !== '0' && cat !== 'a';
  const showSubcat = cat === '7' || cat === '6';
  const emailLabel = showSupName ? 'Email ID' : 'Email ID (optional)';
  const showCatDetails = cat !== '7' && cat !== '6' && cat !== 'a' && cat !== '0' && catDetails !== '';

  return (
    <>
      <BackDropLoad wait={wait} />
      <AccountHeader
        kicker="Account"
        title="Complete your profile"
        subtitle="Tell us about yourself so we can tailor your ESAY experience."
      />

      <FormCard onSubmit={finishProfile}>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
          <SelectField
            label="Category"
            value={cat}
            onChange={(e) => {
              setCat(e.target.value);
              setSubcat('0');
              setCatDetails('');
              if (e.target.value !== '6' && e.target.value !== '7' && e.target.value !== 'a' && e.target.value !== '0') {
                getCatDetails(e.target.value);
              }
            }}
            error={error === 1}
            errorMsg="Please choose a category."
            required
          >
            <option value="0">Please select a category</option>
            <option value="a">Regular user</option>
            {cats && cats.map((c) => (
              <option key={c.category_id} value={c.category_id}>{c.category_name}</option>
            ))}
          </SelectField>

          {showSubcat && (
            <SelectField
              label="Sub-category"
              value={subcat}
              onChange={(e) => setSubcat(e.target.value)}
              error={error === 2}
              errorMsg="Please choose a sub-category."
              required
            >
              <option value="0">Please select a sub-category</option>
              {subcats && subcats.map((sc) => (cat === sc.category_ids ? (
                <option key={sc.sub_category_id} value={sc.sub_category_id}>{sc.sub_category_name}</option>
              ) : null))}
            </SelectField>
          )}

          {showSupName && (
            <Field
              label="Service provider / supplier name"
              value={supname}
              onChange={(e) => setSupname(e.target.value)}
              error={error === 3}
              errorMsg="Please enter a name."
              required
            />
          )}

          <Field
            label={emailLabel}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={error === 4}
            errorMsg="Please enter a valid email ID."
            required={showSupName}
            icon={<Icon.Mail className="h-4 w-4" />}
          />

          <div>
            <label className="mb-1.5 block text-[10.5px] font-bold uppercase tracking-[0.14em] text-fg-tertiary">
              Location <span className="ml-1 text-amber">*</span>
            </label>
            <AutoCompLoc compact error={error === 8} loc={loc} setloc={updateLoc} label="Where" required={false} />
            {error === 8 && (
              <div className="mt-1.5 text-[11px] text-red-400">Please select your location.</div>
            )}
          </div>

          {cat === '7' && (
            <Field
              label="Experience in years (optional)"
              value={exp}
              onChange={(e) => setExp(e.target.value)}
            />
          )}

          {cat === '7' && (
            <Field
              label="Qualification (optional)"
              value={qual}
              onChange={(e) => setQual(e.target.value)}
            />
          )}

          {cat === '6' && (
            <Field
              label="Courses (optional)"
              value={courses}
              onChange={(e) => setCourses(e.target.value)}
            />
          )}

          {(cat === '7' || cat === '6') && (
            <ToggleSwitch
              label="Profile visibility"
              checked={showhide === '1'}
              onChange={() => setShowhide(showhide === '1' ? '0' : '1')}
              hint="Show or hide your profile from the public directory."
            />
          )}

          {/* About this category */}
          {showCatDetails && (
            <div className="sm:col-span-2 relative overflow-hidden rounded-xl border border-amber/24 bg-amber/5 p-4 flex gap-3">
              <span aria-hidden className="absolute left-0 top-3 bottom-3 w-[3px] rounded-r-full bg-amber" />
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-amber/15 text-amber">
                <Icon.Info className="h-4 w-4" />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-[12px] font-bold uppercase tracking-[0.14em] text-amber mb-1">
                  About this category
                </h3>
                <div className="text-[12.5px] leading-[1.6] text-fg-secondary [&_*]:text-fg-secondary">
                  {parse(catDetails)}
                </div>
              </div>
            </div>
          )}

          <div className="sm:col-span-2 pt-1">
            <PrimaryButton type="submit" loading={wait} icon={<Icon.ArrowRight className="h-4 w-4" />}>
              {wait ? 'Please wait…' : 'Finish profile setup'}
            </PrimaryButton>
          </div>
        </div>
      </FormCard>
    </>
  );
};
